// TODO: Prob separate this out:
jQuery(document).ready(function ($) {
  navigator.permissions.query({ name: "clipboard-write" }).then(result => {
    if (result.state == "granted" || result.state == "prompt") {
      $('[data-clipboard-copy]').on('click', (event) => {
        updateClipboard(event.target.dataset.clipboardCopy)
      });
    }
  });
})

function updateClipboard(newClip) {
  navigator.clipboard.writeText(newClip).then(function () {
    /* clipboard successfully set */
  }, function () {
    /* clipboard write failed */
  });
}